import styled from "styled-components";
import image from '../../assets/index.jpg';

export const HomeContainer = styled.div`
  background-image: url(${image});
  background-size: cover;
  background-repeat: no-repeat;
  height: 70vh;
`;

export const HomeContent = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white !important;

  p {
    color: white;
  }
`;
